import React from 'react';
import BreadCrumb from '@prisjakt/ui-breadcrumb';

import { bemGenerator } from '@prisjakt/ui-base';

import { AppContext } from '@prisjakt/ui-app-context';
import AlertSettings from './components/alert-settings';
import ProfileSettings from './components/profile-settings';
import UserData from './components/user-data';
import PageContent from '../../../components/page-content';
import PageHeader from '../../../components/page-header';

import './sagas';
import './sagas/alerts';

import './index.scss';

const styles = bemGenerator('settings', ['section']);

class Settings extends React.PureComponent {
  renderBreadcrumb() {
    const { t } = this.context;
    const path = [
      {
        id: '1',
        name: t('account', 'settings.title'),
        pathName: '/account/settings',
      },
    ];

    return (
      <BreadCrumb
        homeText={t('common', 'breadcrumb.home')}
        path={path}
        firstPathSelectable
      />
    );
  }

  render() {
    const { t } = this.context;
    return (
      <div className={styles.block}>
        <PageContent>
          {this.renderBreadcrumb()}

          <PageHeader title={t('account', 'settings.title')} />

          <div className={`columns small-12 medium-6 ${styles.section}`}>
            <ProfileSettings />
            <AlertSettings shouldSave />
            <UserData />
          </div>
        </PageContent>
      </div>
    );
  }
}

Settings.contextType = AppContext;

export default Settings;
